<template>
  <div class="col-xl-4 col-md-6">
    <card class="card-stats">
      <div class="statistics statistics-horizontal">
        <div class="info info-horizontal">
          <div class="row patient-details details">
            <div class="col-4 col-md-4">
              <div class="row">
                <div class="col-12">
                  <div class="profile-image" :style="{
                      backgroundImage:
                        'url(' +
                        (patient.profileImage
                          ? baseUrl + '/file/' + patient.profileImage
                          : avatarImage) +
                        ')',
                    }"></div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <div v-if="patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                    <span>
                      <i class="fa fa-mars"></i>
                    </span>
                  </div>
                  <div v-if="patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                    <span>
                      <i class="fa fa-venus"></i>
                    </span>
                  </div>
                  <div v-if="patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                    <span>
                      <i class="fa fa-transgender-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-8 col-md-8 right">
              <slot>
                <div class="row">
                  <div class="col-md-1 col-1">
                    <span>
                      <i class="fa fa-user"></i>
                    </span>
                  </div>
                  <div class="col-md-8 col-8">
                    <span>{{ patient.firstName }} {{ patient.lastName }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-1 col-1">
                    <span>
                      <i class="fa fa-info-circle"></i>
                    </span>
                  </div>
                  <div class="col-md-10 col-10">
                    <span>{{ patient.patientId }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-1 col-1">
                    <span>
                      <i class="fa fa-birthday-cake"></i>
                    </span>
                  </div>
                  <div class="col-md-8 col-8">
                    <span>{{ getAge(patient.dob) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-1 col-1">
                    <span>
                      <i class="fa fa-mobile"></i>
                    </span>
                  </div>
                  <div class="col-md-8 col-8">
                    <span>{{ patient.mobileNumber }}</span>
                  </div>
                </div>
              </slot>
            </div>
            <div class="col-12" style="text-align:center">
              <n-button type="primary" round @click.native="$router.push({ path: '/consentmanagement'});$store.commit('setState', {
              stateName: 'patient',
              stateValue: patient,
              })" size="sm">
                Consent management
              </n-button>
            </div>
          </div>
        </div>
      </div>
      <div class="stats text-center" slot="footer">
        <n-button v-if="!user.roles.includes('lab-operator')" type="primary" round icon class="btn-padding mr-2 light" @click.native.stop="editPatient(patient)">
          <i class="fa fa-edit"></i>
        </n-button>
        <n-button type="primary" round icon class="btn-padding mr-2 light" @click.native.stop="addVitals(patient)">
          <i class="fa fa-heartbeat"></i>
        </n-button>
        <n-button type="primary" round icon class="btn-padding mr-2 light" @click.native.stop="goToQuestionnaire(patient)">
          <i class="fa fa-clipboard-list"></i>
        </n-button>
        <n-button type="primary" round icon class="btn-padding mr-2 light" @click.native.stop="goToFiles(patient)">
          <i class="fa fa-file"></i>
        </n-button>
        <n-button type="primary" round icon class="btn-padding mr-2 light" @click.native.stop="goToNotes(patient)">
          <i class="fas fa-file-prescription"></i>
        </n-button>
      </div>
    </card>
  </div>
</template>
<script>
import "sweetalert2/dist/sweetalert2.css";
import avatarImage from "@/assets/img/proAvatar.png";
var moment = require("moment");

export default {
  components: {},
  data() {
    return {
      avatarImage,
    };
  },
  props: ["patient"],
  methods: {
    async editPatient(patient) {
      this.$router.push({ path: "/patients/edit/" + patient._id });
    },
    async addVitals(patient) {
      /*       this.$store.commit("setState", {
        stateName: "patient",
        stateValue: patient,
      });
      this.$router.push({
        path: "/vitals/" + patient._id,
      }); */

      /*       if (this.user && this.user.endpoint) {
        this.$store.commit("setState", {
          stateName: "endpoint",
          stateValue: this.user.endpoint,
        });
      } */
      this.$store.commit("setState", {
        stateName: "patient",
        stateValue: patient,
      });
      this.$router.push({ path: "/patientvitals/" + patient._id });
    },
    async goToQuestionnaire(patient) {
      this.$router.push({ path: "/questionnaires/" + patient.patientId });
    },
    async createVisit(patient) {
      await this.$store.dispatch("getDoctors");
      await this.$store.dispatch("getLabOperators");
      this.$router.push({ path: "/visit", query: { patientId: patient._id } });
    },
    goToFiles(patient) {
      this.$store.commit("setState", {
        stateName: "patient",
        stateValue: patient,
      });
      this.$router.push({ path: "/patient/files" });
    },
    goToNotes(patient) {
      this.$store.commit("setState", {
        stateName: "patient",
        stateValue: patient,
      });
      this.$router.push({ path: "/patient/notes" });
    },
  },
};
</script>
<style scoped>
.btn-padding {
  padding: 5px 15px;
  margin-right: 1em;
}
.patient-details .right .fa {
  color: rgba(44, 44, 44, 0.69);
}
.profile-image {
  height: 80px;
  max-width: 100px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 50%;
}
</style>
